import "./OnboardingScreen.scss";
import approvalIcon from "../../../../Assets/Sessions/approval_icon.svg";
import rejectIcon from "../../../../Assets/global/chat_icon_violet.svg";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from "react";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { ADMIN_ROLES, API_RESPONSE, ROUTES, STORAGE_KEYS } from "../../../Utilities/Constants/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import { GetSessionStorageData } from "../../../Services/Helpers/Helper";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Onboarding = () => {
    const navigate = useNavigate();
    const route = useLocation();
    const [userType, setuserType]: any = useState("");
    const [Rejected, setRejected]: any = useState("");
    useEffect(() => {
        let role: any = GetSessionStorageData(STORAGE_KEYS.ROLE);
        setuserType(role);
        //   
    }, []);

    /* Calling Approval refresh API on updating role */
    useEffect(() => {
        if (userType)
            onApprovalRefresh();
    }, [userType])



    /* API call after approval refresh */
    const loggedFirstTime = () => {
        if (userType !== ADMIN_ROLES.SCHOOL || ADMIN_ROLES.UNIVERSITY) {
            axiosInstance.put(API_END_POINTS.FIRST_LOGIN).then((response: any) => {

            })
        }

    };

    /* Update status on page refresh */
    const onApprovalRefresh = () => {
        axiosInstance.get(API_END_POINTS.APPROVAL_REFRESH).then((response: any) => {
            if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
                setRejected(response?.data?.result?.data)
                if (response.data.result.data.is_approved === API_RESPONSE.TRUE) {
                    navigate(ROUTES.WELCOME_SCREEN);
                    loggedFirstTime();
                }
            }
        })

    }
    return (
        <div className="row onboarding-wrapper">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 column-wrapper">
                {Rejected?.is_rejected ? (
                    <div className="approval-image-wrapper">
                        <img className="approval-icon" src={rejectIcon} />
                        <h3 className="approval-text">Admin Rejected your profile</h3>
                        <p>{Rejected?.reason}</p>
                    </div>
                ) : (
                    <div className="approval-image-wrapper">
                        <img className="approval-icon" src={approvalIcon} />
                        <h3 className="approval-text">Waiting for approval</h3>
                    </div>
                )}

                <div className="title-wrapper">
                    <p className="faq-title">Frequently Asked Questions</p>
                </div>

                <div className="accordian-wrapper">

                    <Accordion className="accordian">
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="slot_date_time_wrapper">
                                <div className="slot_date">How long it will take for approval process?</div>
                            </div>
                        </AccordionSummary>
                        <hr />
                        <AccordionDetails>
                            <div className="slot_card_container">
                                <p>Will take upto 2 business days</p>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="accordian">
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="slot_date_time_wrapper">
                                <div className="slot_date">How approval process takes place?</div>
                            </div>
                        </AccordionSummary>
                        <hr />
                        <AccordionDetails>
                            <div className="slot_card_container">
                                <p>Learn & Play Admin will verify documents and approve tutors</p>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className="accordian">
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="slot_date_time_wrapper">
                                <div className="slot_date">What's after approval?</div>
                            </div>
                        </AccordionSummary>
                        <hr />
                        <AccordionDetails>
                            <div className="slot_card_container">
                                <p>Tutor can create sessions and teach students</p>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>

            </div>
        </div>
    )

};

export default Onboarding;